import { ScopeSelector, type ScopeMode } from '@/components/common/scope-selector';
import { useAuthStore } from '@/stores/auth-store';

export interface RequestsScopeFilterProps {
  scope: ScopeMode;
  scopeId?: string;
  onScopeChange: (scope: ScopeMode, scopeId?: string) => void;
}

/**
 * Requests page-specific scope filter.
 * Wraps the shared ScopeSelector with "Requests" as the entity label.
 */
export function RequestsScopeFilter({ scope, scopeId, onScopeChange }: RequestsScopeFilterProps) {
  const isAdmin = useAuthStore((state) => state.user?.isGlobalAdmin ?? false);

  return (
    <ScopeSelector
      scope={scope}
      {...(scopeId !== undefined && { scopeId })}
      onScopeChange={onScopeChange}
      entityLabel="Requests"
      isAdmin={isAdmin}
    />
  );
}
